import React from 'react';
import { matchPath } from 'react-router-dom';
import { Type } from '@lendi/lala-react';
import { TeamNavTab } from '@lendi/team-navigation';

import { ENVIRONMENT, TEAM_VIEW_BASE_NAME, TEAM_VIEW_URL_BASE } from '@funnels/constants';
import { getViewType } from '@funnels/utils';

import Debug from '../_Debug';
import { Navbar } from '../Navbar';
import { MinimalTeamNav, TeamNav } from '../TeamNav';

interface NavWrapperProps {
  children: React.ReactNode;
  teamNavTab?: TeamNavTab;
}

function NavWrapper(props: NavWrapperProps) {
  const shouldUseTeamNavigation = getViewType() === Type.Team;
  const shouldRenderToolBar = ENVIRONMENT !== 'production';

  if (shouldUseTeamNavigation) {
    if (
      matchPath(window.location.pathname, {
        path: [
          `${TEAM_VIEW_BASE_NAME}${TEAM_VIEW_URL_BASE}/applications/`,
          `${TEAM_VIEW_BASE_NAME}${TEAM_VIEW_URL_BASE}/application/:id/copy/`,
        ],
        exact: true,
        strict: false,
      })
    ) {
      return (
        <div data-component="minimal-teamview-nav">
          <MinimalTeamNav>
            {shouldRenderToolBar && <Debug.ToolBar />}
            {props.children}
          </MinimalTeamNav>
        </div>
      );
    }

    return (
      <div data-component="teamview-nav">
        <TeamNav teamNavTab={props.teamNavTab}>
          {shouldRenderToolBar && <Debug.ToolBar />}
          {props.children}
        </TeamNav>
      </div>
    );
  }

  return (
    <div data-component="customer-navbar">
      {shouldRenderToolBar && <Debug.ToolBar />}
      <Navbar />
      {props.children}
    </div>
  );
}

export default NavWrapper;
